import { IUploadFileEntity, IUploadFileEntityResponse } from '@/graphql/__generated__/global/types';

export function isFullUrl(url: string): boolean {
    return /^https?:\/\//.test(url);
}

export const getImageUrl = (image?: IUploadFileEntityResponse | IUploadFileEntity): string => {
    const imgUrl = (image as IUploadFileEntityResponse)?.data?.attributes?.url ?? (image as IUploadFileEntity)?.attributes?.url;

    if (!imgUrl) {
        return '';
    }

    return isFullUrl(imgUrl) ? imgUrl : `${process.env.NEXT_PUBLIC_STRAPI_BACKEND_URL}${imgUrl}`;
};
